<template>
	<a @click="toggleHelp" style="cursor: pointer"><i class="fas fa-question-circle"></i>&nbsp;Help</a>
</template>

<script>
export default {
	props: {
	},
	data: function () {
		return {
			isOpen: false
		}
	},
	mounted() {
		window.addEventListener("load", () => this.windowLoaded());
	},
	methods: {
		windowLoaded() {
			FreshworksWidget('hide', 'launcher');
		},
		toggleHelp() {
			if (this.isOpen) {
				FreshworksWidget('close');
				FreshworksWidget('hide', 'launcher');
				this.isOpen = false;
			}
			else {
				this.isOpen = true;
				FreshworksWidget('show', 'launcher');
				FreshworksWidget('open');
			}
		}
	}
}

</script>